import { memo } from 'react';
import Resource from 'ui/layouts/Resource';
import TransactionTable from './TransactionTable';

const Transactions = () => (
    <Resource
        breadcrumbsProps={{
            heading: 'Transactions',
            links: [{ name: '' }],
            sx: {
                mb: 0
            }
        }}
    >
        <TransactionTable />
    </Resource>
);

export default memo(Transactions);
